// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpandableContentListBlock_container__Ka7Ml","blockList":"ExpandableContentListBlock_blockList__XWNQ2","footer":"ExpandableContentListBlock_footer__fqVvD"};